import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import serialize from 'form-serialize';
import Button from '@spothero/ui/button';
import Form from '@spothero/ui/form';
import FormElementError from '@spothero/ui/form-element-error';
import FormGroup from '@spothero/ui/form-group';
import Label from '@spothero/ui/label';
import TextInput from '@spothero/ui/text-input';
import EnvironmentUtils from '@spothero/utils/environment';
import ValidationUtils from '@spothero/utils/validation';
import UserUtils from 'user/user-utils';

export default class GuestLogin extends Component {
    static propTypes = {
        focus: PropTypes.bool,
        onUserChange: PropTypes.func.isRequired
    };

    _onSubmit = evt => {
        const {
            email
        } = serialize(evt.target, {hash: true});

        this.props.onUserChange({
            user: {
                status: UserUtils.AUTH_STATE.GUEST,
                email
            }
        });
    }

    render() {
        const {
            focus
        } = this.props;
        const emailClasses = classNames(
            'email-control',
            'GuestLogin-email'
        );

        return (
            <Form
                id="GuestLogin-form"
                className="GuestLogin"
                onSubmit={this._onSubmit}
            >
                <h2>Check Out as Guest</h2>
                <FormGroup className="FormGroup-responsive">
                    <TextInput
                        required
                        className={emailClasses}
                        type="email"
                        name="email"
                        label={<Label>Email</Label>}
                        placeholder={(EnvironmentUtils.isMobileDevice()) ? 'Email' : ''}
                        pattern={ValidationUtils.EMAIL}
                        error={<FormElementError>Please enter a valid email.</FormElementError>}
                        focus={focus}
                        helpNode="Where should we email your parking pass?"
                    />
                </FormGroup>
                <div className="FormActions">
                    <Button
                        className="GuestLogin-submit"
                        color="primary"
                        type="submit"
                    >
                        Continue as Guest
                    </Button>
                </div>
            </Form>
        );
    }
}
